import {urls} from "./urls";
import {get_response, post_response} from "../helper/request";
import querystring from "query-string";


export const getGlobalConfig = () => {
    return new Promise((resolve, reject) => {
        let url = urls.GET_GLOBAL_CONFIGS
        get_response(url).then(response => resolve(response)).catch(err => reject(err))
    });
}

export const setGlobalConfig = (key, value) => {
    return new Promise((resolve, reject) => {
        let url = urls.SET_GLOBAL_CONFIGS;
        let data = {'key': key, 'value': value};
        post_response(url, querystring.stringify(data))
            .then(response => resolve(response))
            .catch(err => reject(err))
    });
}
